import React, { useEffect } from 'react'
import { useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Container, Image } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useTransition } from 'react-spring'
import tf_logo from 'img/tf-logos/tf_logo_fullcolor.svg'
import { AuthContext, setVocative } from 'exports'
import Menu from 'components/menu/Menu'
import { appRoutes } from 'constants/routes/Routes'
import ChangeLanguage from '../ChangeLanguage/ChangeLanguage'
import i18next from 'i18next'

function Header() {
	const urlSearch = window.location.search.toLowerCase()
	const urlPath = window.location.pathname.toLowerCase()

	const userName =
		i18next.language === 'lt'
			? setVocative(
					JSON.parse(
						sessionStorage.getItem('customerName')?.toString() ??
							'null'
					)
			  )
			: JSON.parse(
					sessionStorage.getItem('customerName')?.toString() ?? 'null'
			  )
	const { t } = useTranslation()
	const { isAuthenticated } = useContext(AuthContext)

	const [isShown, setIsShown] = useState(false)
	const [isApplication, setIsApplication] = useState<boolean>(false)

	const transitions = useTransition(isShown, null, {
		from: { transform: 'translate3d(320px,0,0)', opacity: 0.5 },
		enter: { transform: 'translate3d(0px,0,0)', opacity: 1 },
		leave: { transform: 'translate3d(500px,0,0)', opacity: 0.5 },
		config: { duration: 400 },
	})

	const logo = tf_logo

	useEffect(
		() => {
			urlSearch.includes('application') || urlPath.includes('application')
				? setIsApplication(true)
				: setIsApplication(false)
			return
		},
		[] //eslint-disable-line
	)

	return (
		<>
			{isAuthenticated && (
				<>
					<div
						className={`header-outer d-flex justify-content-center ${
							isApplication
								? 'application-header'
								: 'mypages-header'
						}`}>
						<div className="header-desktop" id="header-desktop">
							<Container className="d-flex flex-row justify-content-between header-container">
								{isApplication ? (
									<Image
										src={logo}
										className="img-responsive tfbank-logo-header"
										alt="TF Bank AB"
									/>
								) : (
									<Link to={appRoutes.homePage}>
										<Image
											src={logo}
											className="img-responsive tfbank-logo-header"
											alt="TF Bank AB"
										/>
									</Link>
								)}
								{isApplication ? null : <ChangeLanguage />}

								{isApplication ? (
									<div className="sign-out">
										<Link
											className="btn-border"
											to={appRoutes.logout}>
											{t('SignOut')}
										</Link>
									</div>
								) : (
									<div
										id="nav-icon1"
										className="pointer"
										onClick={() => setIsShown(true)}
										style={{
											visibility: isShown
												? 'hidden'
												: 'visible',
										}}>
										<span></span>
										<span></span>
										<span></span>
									</div>
								)}
							</Container>

							{transitions.map(
								({ item, key, props }) =>
									item && (
										<Menu
											key={key}
											hide={() => setIsShown(false)}
											props={props}
											userName={userName}
										/>
									)
							)}
						</div>
					</div>
				</>
			)}
		</>
	)
}

export default Header